import { useContext } from "react";
import useHasPermission from "src/utils/hooks/security/useHasPermission";
import {
  companyMultisportCardWaitingRoom,
  companySubscriptionsWaitingRoom,
} from "src/utils/RoleBasedSecurity/permissions";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";

const useInitialFilters = () => {
  const { userInfo } = useContext(RbsContext);

  const permissions = userInfo.getPermissions();

  const hasCompanyMultisportCardWaitingRoom = permissions.includes(
    companyMultisportCardWaitingRoom
  );
  const hasCompanySubscriptionsWaitingRoom = permissions.includes(
    companySubscriptionsWaitingRoom
  );

  const filters = {};

  if (
    hasCompanyMultisportCardWaitingRoom &&
    !hasCompanySubscriptionsWaitingRoom
  ) {
    filters.type = "MS";
  } else if (
    !hasCompanyMultisportCardWaitingRoom &&
    hasCompanySubscriptionsWaitingRoom
  ) {
    filters.type = "ABO";
  }

  return filters;
};

export default useInitialFilters;
